export default {
  WEB_TEXT_PLAIN: 'web text/plain',
};
